import {
  Component,
  ViewContainerRef,
  computed,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import {
  AttendeeAddEntryEvent,
  AttendeeItemMode,
  CalendarAttendee,
} from '@maximizer/outlook/shared/domain';
import { AttendeeNotifyEvent } from '@maximizer/outlook/shared/ui';
import { TranslatePipe } from '@ngx-translate/core';
import {
  KENDO_LISTVIEW,
  PageChangeEvent,
  PagerSettings,
} from '@progress/kendo-angular-listview';
import { OutlookCalendarAttendeeItemComponent } from '../attendee-item/attendee-item.component';

@Component({
  selector: 'maximizer-outlook-calendar-not-in-maximizer-list',
  templateUrl: './not-in-maximizer-list.component.html',
  imports: [
    KENDO_LISTVIEW,
    TranslatePipe,
    OutlookCalendarAttendeeItemComponent,
  ],
})
export class OutlookCalendarNotInMaximizerListComponent {
  readonly viewContainerRef = inject(ViewContainerRef);

  attendees = input<CalendarAttendee[]>([]);
  mode = input<AttendeeItemMode>('read');
  userEmails = input<Set<string>>(new Set());

  addEntry = output<AttendeeAddEntryEvent>();
  navigate = output<CalendarAttendee>();
  notify = output<AttendeeNotifyEvent>();

  pageSize = 4;

  defaultPagerSettings: PagerSettings = {
    position: 'bottom',
    pageSizeValues: false,
    info: false,
    previousNext: true,
    type: 'numeric',
    buttonCount: 4,
  };

  showPagerNavigation = computed(() =>
    this.attendees().length > this.pageSize ? this.defaultPagerSettings : false,
  );

  private readonly skip = signal(0);

  clampedSkip = computed(() => {
    const pageCount = Math.ceil(this.attendees().length / this.pageSize);
    const lastPageSkip = Math.max(0, (pageCount - 1) * this.pageSize);
    return Math.min(this.skip(), lastPageSkip);
  });

  listViewData = computed(() => {
    const skip = this.clampedSkip();
    return {
      data: this.attendees().slice(skip, skip + this.pageSize),
      total: this.attendees().length,
    };
  });

  onPageChange(event: PageChangeEvent): void {
    this.skip.set(event.skip);
  }
}
